interface DefaultCellProps {
    value: string | number | null | undefined;
    minWidth?: number | null;
}

export default function MoneyCell({ value, minWidth }: DefaultCellProps) {
    if (value === null || value === undefined) {
        return (
            <div
                className={`${!navigator.userAgent.includes("Safari") ? "min-w-max" : "whitespace-nowrap"} min-w-[100px] text-center`}
                style={{
                    minWidth: minWidth || 0,
                }}
            >
                -
            </div>
        );
    }

    return (
        <p
            className={` ${!navigator.userAgent.includes("Safari") ? "min-w-max" : "whitespace-nowrap"} min-w-[100px] text-center`}
        >
            {(value as number).toFixed(2)}
        </p>
    );
}
